import {Component, EventEmitter, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';

import {HttpService} from '../../../services/http/http.service';
import {UserService} from '../../../services/user.service';
import {IClaims} from '../../../interfaces/IClaims';
import {SupervisorsocketService} from '../../../services/supervisorsocket.service';
import {RequestService} from '../../../services/request.service';
import * as moment from 'moment';
import {MyCONST} from '../../../CONST/myCONST';
import {USSDGWSimulatorService} from '../../../services/ussdgw-simulator.service';

@Component({
  selector: 'actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.scss']
})
export class ActionsComponent implements OnInit {
  notifications: any[];
  messages: any[];
  files: any[];
  closeDropdown: EventEmitter<boolean>;
  closeDropdown2: EventEmitter<boolean>;
  @Input() layout: string;
  loading = false;

  constructor(
    private httpSv: HttpService,
    private router: Router,
    public user: UserService,
    private  supervisor_socket: SupervisorsocketService,
    private ussdgw_simulator_socket: USSDGWSimulatorService,
    public _request: RequestService
  ) {
    this.notifications = [];
    this.messages = [];
    this.files = [];
    this.closeDropdown = new EventEmitter<boolean>();
    this.closeDropdown2 = new EventEmitter<boolean>();
    this.layout = 'vertical';
  }

  ngOnInit() {
    // this.getData('assets/data/navbar-notifications.json', 'notifications');
    // this.getData('assets/data/navbar-messages.json', 'messages');
    this.getData('assets/data/navbar-files.json', 'files');

    if (this.user.authenticated.type === 'supervisor') {
      this.user.claim_loading_status = true;
      this.getListClaims().then(() => {
        this.user.claim_loading_status = false;
        this.socket_claims_listening();
      });
    }
    if(this.user.authenticated.type === 'super_admin'){
      this.ussdgwSocketListener();
    }
  }

  ussdgwSocketListener() {
    if (!this.ussdgw_simulator_socket.ussdgw_simulator) {
      console.log('Actions.Components : rrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr');
      return;
    }
    this.ussdgw_simulator_socket.listen('test').subscribe((data) => {
      console.log('Actions.Components :aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa', data);
    });

  }

  async getListClaims() {
    this.user.list_claims = [];
    this.user.notifications = [];
    const UrL = 'auth/supervisor/claims';
    this.loading = true;
    const results = await this.user.get_data(UrL);
    this.user.list_claims = results;
    this.loading = false;
    results.forEach(v => {
      this.user.notifications.push({icon: '', data: v, title: 'HOME.menu.claims', detail: 'TR. ' + v.transaction_id});
    });

    return results;
  }

  socket_claims_listening() {
    if (!this.supervisor_socket.supervisor_socket) {
      return;
    }
    this.supervisor_socket.supervisor_socket.once('newClaim', (data: IClaims) => {
      console.log('new claim data', data);
      this._request.notifyMessage('info', '', 'Nouveau ticket #' + data.transaction_id);
      this.user.list_claims.unshift(data);

      // Remove duplicate
      const removeDuplicate = new Set(this.user.list_claims);
      this.user.list_claims = Array.from(removeDuplicate);

      // notifs
      this.user.notifications = [];
      this.user.list_claims.forEach(v => {
        this.user.notifications.push({icon: '', data: v, title: 'HOME.menu.claims', detail: 'TR. ' + v.transaction_id});
      });

      const audio = new Audio();
      audio.src = 'assets/audio/alert.mp3';
      audio.load();

      setTimeout(() => {
        const audiPlay = audio.play();
      }, 0);

    });
  }

  select_claim(event: Event, data: IClaims) {
    event.preventDefault();
    this.user.selected_claim = data;
    this.user.filterClaimTransID = data.transaction_id;
    localStorage.setItem('selected_claim', JSON.stringify(data));
    this.getSMSBetweenClaims(data.transaction_id).then(res => {
      this.router.navigate(['/vertical/notifications']);
      this.onCloseDropdown2();
    });
    // this.user.getTransactionByClaims(data.transaction_id, this.fromDate, this.toDate, this.filterStatus);
  }

  async getSMSBetweenClaims(transaction_id) {
    this.user.claims_sms_between = [];
    const UrL = `auth/supervisor/sms_between/transaction/${transaction_id}`;
    this.loading = true;
    const results = await this.user.get_data(UrL);
    this.user.claims_sms_between = results;
    this.loading = false;
    return results;
  }

  showAllNotifs() {
    event.preventDefault();
    this.cleanSelectedClaim();
    this.router.navigate(['/vertical/notifications']);
    this.onCloseDropdown2();

  }

  cleanSelectedClaim() {
    this.user.filterClaimTransID = '';
    this.user.selected_claim = {};
    localStorage.removeItem('selected_claim');
    this.user.claims_sms_between = [];
  }

  format_date(created_at: string) {
    return moment(created_at).format('MMM DD, YY à h:mm').toString();
  }

  getData(url: string, dataName: string) {
    this.httpSv.getData(url).subscribe(
      data => {
        this[dataName] = data;
      },
      err => {
        console.log(err);
      }
    );
  }

  onCloseDropdown() {
    this.closeDropdown.emit(true);
  }

  onCloseDropdown2() {
    this.closeDropdown2.emit(true);
  }

  goTo(event: Event, link: string, layout: string = '') {
    event.preventDefault();

    this.onCloseDropdown();

    setTimeout(() => {
      this.router.navigate([layout ? layout : this.layout, link]);
    });
  }

  logout(event: Event, link: string, layout: string = '') {
    this.user.authenticated = {};
    localStorage.removeItem(MyCONST.Token);
    localStorage.removeItem(MyCONST.authenticated);
    this.goTo(event, link, layout);
  }


}
